import React from 'react'
import styled from 'styled-components'

import { CustomInput } from 'reactstrap'

// import { FONTS } from '../../constants'

export const Checkbox = (props) => {
  return (
    <CheckboxInput
      type='checkbox'
      { ...props }
    />
  )
}

const CheckboxInput = styled(CustomInput)`
`



// WEBPACK FOOTER //
// ./src/components/input/check-box.js